export default "__VITE_ASSET__9c161033__"